import { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css'

// Context
import { AdminProvider, useAdmin } from './context/AdminContext'

// Components
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import Products from './components/Products'
import Categories from './components/Categories'
import Orders from './components/Orders'
import Analytics from './components/Analytics'
import Users from './components/Users'
import Settings from './components/Settings'
import Sidebar from './components/Sidebar'
import Header from './components/Header'

function AppContent() {
  const { isAuthenticated, user, logout } = useAdmin()

  if (!isAuthenticated) {
    return <Login />
  }

  return (
    <div className="admin-app">
      <Sidebar />
      <div className="admin-main">
        <Header user={user} onLogout={logout} />
        <main className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/users" element={<Users />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  )
}

function App() {
  return (
    <AdminProvider>
      <AppContent />
    </AdminProvider>
  )
}

export default App
